define('type/album/Serum.Album',[],function(){
  'use strict';

  var supports = {
    replaceState: Boolean(history.replaceState),
    pageOffset: window.pageXOffset !== undefined,
    css1Compat: ((document.compatMode || '') === 'CSS1Compat')
  };

  var items = [];
  var index = Number(location.search.split(/[?&]index=/)[1]) || null;
  var dialog = document.createElement('div');
  var dialogContent;
  var currentHash;
  var bodyNoScroll = ' dialog-body-no-scroll';
  var htmlNoScroll = ' dialog-html-no-scroll';
  var scrollYOnOpen = 0;

  function getScrollY(){
    return (supports.pageOffset) ? window.pageYOffset : document.body.scrollTop;
  }

  function setScrollY(toScrollY){
    var toScrollYInt = Math.round(toScrollY);
    // MDN sample suggests that document.compatMode === 'CSS1Compat' should determine
    // that documentElement should be used, otherwise document.body.
    // Unfortunately, Safari desktop + Safari/Chrome ios do not agree.
    // Setting both seems wrong, but it appears to work.
    document.documentElement.scrollTop = toScrollYInt;
    document.body.scrollTop = toScrollYInt;
  }

  //Setup dialog
  dialog.hidden = true;
  dialog.className = 'album-dialog nrk-color-invert';
  dialog.innerHTML = '<header class="album-dialog__heading">' +
      '<div class="nrk-logo"></div>' +
      '<button data-album="close" class="album-dialog__close nrk-button nrk-button--o album-dialog__first-focusable"><span class="nrk-sr">Lukk galleri</span><svg xmlns="http://www.w3.org/2000/svg" version="1.1" class="close-icon" aria-hidden="true"><use xlink:href="#nrk-close" /></svg></button>' +
      '</header>'
  + '<div class="album-dialog__content" tabindex="-1">'
    + '<div class="album-dialog__title"><div class="album-dialog__title-background"></div><h2></h2><p class="album-dialog__title-ingress"></p></div>'
    + '<div class="album-dialog__items"></div>'
  + '</div>';

  function close(){
    document.body.className = document.body.className.replace(bodyNoScroll, '');
    document.documentElement.className = document.documentElement.className.replace(htmlNoScroll, '');
    dialog.hidden = true;
    currentHash = false;
    index = null;
    if (supports.replaceState){
      history.replaceState({}, document.title, location.pathname);
    }
    setScrollY(scrollYOnOpen);
    trackEvent('Closed');
  }

  //Base API
  function open(opts){
    if(!dialog.hidden){
      return;
    }
    var toContainer = dialog.querySelector('.album-dialog__items');
    toContainer.innerHTML = opts.items;
    scrollYOnOpen = getScrollY();
    document.body.appendChild(dialog);
    dialogContent = dialog.querySelector('.album-dialog__content');
    var titleElement = dialog.querySelector('.album-dialog__title');
    function handleCoverImageComplete(e){
      var coverImage = e ? e.target : opts.coverImage;

      titleElement.querySelector('.album-dialog__title-background').style.backgroundImage = 'url("' + coverImage.currentSrc + '")';
    }
    titleElement.querySelector('h2').textContent = opts.title;
    titleElement.querySelector('.album-dialog__title-ingress').textContent = opts.description;
    if (opts.coverImage){
      if (opts.coverImage.complete){
        handleCoverImageComplete();
      } else {
        opts.coverImage.addEventListener('load', handleCoverImageComplete);
      }
    }
    items = [].slice.call(toContainer.children);
    currentHash = opts.album;
    document.body.className += bodyNoScroll;
    document.documentElement.className += htmlNoScroll;
    dialog.hidden = false;

    if (typeof index === 'number'){
      selectItem(index);
      slideTo(index);
    } else {
      selectItem(0, true);
    }
    refreshLastItemMarginBottom();
    trackEvent('Opened');
  }

  function verticallyCenteredOffsetTop(element){
    var elementHeight = element.offsetHeight;
    var viewPortHeight = window.innerHeight;
    var offsetTop = (viewPortHeight - elementHeight)/2;
    return offsetTop < 50 ? 50 : offsetTop;
  }

  function slideTo(to){ //to can be index or '+1'/'-1'
    var currentIndex = (typeof index === 'number') ? index : -1;
    var toIndex = (typeof to === 'string') ? (currentIndex + Number(to)) : to;
    var item = items[toIndex];
    if (item){
      var nowY = dialogContent.scrollTop;
      var endY = item.offsetTop - verticallyCenteredOffsetTop(item);
      clearTimeout(slideTo.timer);
      var anim = function(){
        if (Math.abs(endY - nowY) > 5) {
          var toScrollTop = Math.round(nowY+= (endY - nowY) / 5);
          dialogContent.scrollTop = toScrollTop;
          slideTo.timer = setTimeout(anim, 16);
        }
      };
      anim();
    }
  }

  function refreshLastItemMarginBottom(){
    if (dialog){
      if (items.length){
        var lastItem = items[items.length -1];
        var lastItemHeight = lastItem.offsetHeight;
        var marginBottom = 'calc(50vh - ' + Math.round(lastItemHeight/2 + 0.5) + 'px)';
        lastItem.style.setProperty('margin-bottom', marginBottom);
      }
    }
  }

  /* Utilities
  --------------------------------------------------------------------*/

  function debounce(callback, ms) {
    var timer;
    return function(){
      var args = arguments;
      var self = this;
      clearTimeout(timer);
      timer = setTimeout(function(){
        callback.apply(self, args);
      }, ms);
    };
  }

  function trackEvent(action) {
    if(window.ga){
      window.ga('send', 'event', {
        'eventCategory': 'Album',
        'eventAction': action
      });
    }
  }

  function setPermalink(index){
    if (supports.replaceState){
      var path = location.pathname;
      var indexQueryParam = (typeof index === 'number') ? '?index=' + index : '';
      history.replaceState({}, document.title, path + indexQueryParam + (currentHash || ''));
    }
  }

  function firstFocusableElement(){
    return dialog && dialog.querySelector('.album-dialog__close');
  }

  function lastFocusableElement(){
    var selector = '.album-dialog__image-share';
    if (dialog){
      var elements = dialog.querySelectorAll(selector);
      if (elements && elements.length){
        var lastShareElement = elements[elements.length - 1];
        var lastButton = lastShareElement.querySelector('.album-dialog__image-share-buttons:not([hidden]) > a:last-child');
        return lastButton || lastShareElement.querySelector('.album-dialog__toggle-image-share');
      }
      return firstFocusableElement();
    }
    return null;
  }

  function handleTabKeyEvent(event){
    if (dialog) {
      var firstFocusable = firstFocusableElement();
      var lastFocusable = lastFocusableElement();
      if (!document.activeElement || !dialog.contains(document.activeElement)) {
        event.preventDefault();
        firstFocusable.focus();
        return;
      } else if (document.activeElement === firstFocusable && event.shiftKey){
        event.preventDefault();
        lastFocusable.focus();
        return;
      } else if (document.activeElement === lastFocusable && !event.shiftKey){
        event.preventDefault();
        firstFocusable.focus();
        return;
      }
    }
  }

  function focusInHandler(evt){
    if (dialog){
      var idx = findParentItemIndex(evt.target);
      if (idx !== -1){
        selectItem(idx);
      }
    }
  }

  window.addEventListener('focusin', focusInHandler);

  function onKey(event){
    if (!dialog.hidden){
      if (event.keyCode === 9){
        return handleTabKeyEvent(event);
      }
      if(event.keyCode === 38 || event.keyCode === 37){ //Prev
        if (index){
          slideTo('-1', '500ms');
        }
      }
      if(event.keyCode === 40 || event.keyCode === 39 || event.keyCode === 32){ //Next
        event.preventDefault();
        if (typeof index !== 'number'){
          slideTo(0);
        } else {
          slideTo('+1', '500ms');
        }
      }
      if(event.keyCode === 27){ //ESC
        close();
      }
    }
  }

  function findParentItemIndex(node){
    var parentElement = node.parentElement;
    if (parentElement){
      if (parentElement.className.indexOf('album-dialog__items') !== -1){
        for (var i=0; i < parentElement.children.length; i++){
          if (parentElement.children[i] === node){
            return i;
          }
        }
        return -1;
      }
      return findParentItemIndex(parentElement);
    }
    return -1;
  }

  function onClick(event){
    var descriptionEl;
    for(var el = event.target; el; el = el.parentElement){
      var album = el.getAttribute('data-album');
      if (album){
        if (album === 'close'){
          close();
        } else if(album === 'toggle-share'){
          var next = event.target.nextSibling;
          if (next){
            next.hidden = !next.hidden;
          }
        } else {
          var dialogContentContainer = document.querySelector(album);
          var titleTextElement = el.querySelector('.album__title-text') || el;
          var url = el.getAttribute('data-url');
          var albumContainer = el.parentElement;
          var coverImage = albumContainer.querySelector('.image img');
          var description = (descriptionEl = albumContainer.querySelector('.album__description'))?descriptionEl.textContent: '';
          var options = {
            album: album,
            title: titleTextElement.textContent,
            items: document.querySelector(album).textContent,
            dialogContentContainer: dialogContentContainer,
            url: url,
            coverImage: coverImage,
            description: description
          };
          open(options);
        }
      }
    }
  }

  function selectItem(i, isInitialView){
    items.forEach(function(el, k){
      if (i === k){
        el.style.opacity = 1;
        el.setAttribute('data-is-current-item', 'true');
        if (!isInitialView){
          index = i;
        }
        setPermalink(index);

      } else if (el.style.opacity) {
        el.style.opacity = '';
        el.removeAttribute('data-is-current-item');
      }
    });
  }

  function _handleScroll(event){
    if(!event || event.target === dialogContent){
      var viewportCenterOffsetY = Math.round(dialogContent.scrollTop + window.innerHeight /2);
      var i = items.indexOf([].concat(items).sort(function(a, b){
        var aCenterOffsetY = Math.round(a.offsetTop + a.offsetHeight/2);
        var bCenterOffsetY = Math.round(b.offsetTop + b.offsetHeight/2);
        return Math.abs(aCenterOffsetY - viewportCenterOffsetY) - Math.abs(bCenterOffsetY - viewportCenterOffsetY);
      })[0]);
      if(i !== index){
        selectItem(i);
      }
    }
  }

  var handleScroll = debounce(_handleScroll, 16);

  document.addEventListener('click', onClick);
  document.addEventListener('keydown', onKey);

  window.addEventListener('scroll', handleScroll, true); //Use capture for target handling


  function _resizeHandler(){
    if (!dialog.hidden && index){
      refreshLastItemMarginBottom();
      slideTo(index);

    }
  }

  var resizeHandler = debounce(_resizeHandler, 100);

  window.addEventListener('resize', resizeHandler);

  if (location.hash){
    var fakeEvent = {
      target: document.querySelector('[data-album=\'' + location.hash + '\']'),
      isFake: true
    };
    onClick(fakeEvent);
  }

  var Album = function(){};

  return Album;

});

